export enum ToolsDetailsScreen {
  PART = 'ToolsDetailsPart',
  JOBS = 'ToolsDetailsJobs',
  BATCH = 'ToolsDetailsBatch',
  NC_FILE = 'ToolsDetailsNCFile',
  TOOLS = 'ToolsDetailsTools',
}

export enum ToolsDetailsScreenLink {
  PART = 'part',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  JOBS = 'jobs',
  TOOLS = 'tools',
}

export enum ToolLevelSubScreen {
  GENERAL = 'General',
}

export enum ToolLevelSubScreenLink {
  GENERAL = 'general',
}
